module.exports = __webpack_public_path__ + "f94e9f0fd776e16df210249e1b8f1456.MP3";